import { createAction, props } from '@ngrx/store';

export const updateLoadingUser = createAction(
    '[AUTH] update loading User',
    props<{ value: boolean }>(),
);
